import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';

import { Icon } from '~/eds/src/components/Icon/Icon';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { injectIntl } from 'react-intl';

import styles from '../withSideCollapse/withSideCollapse.styles';

function withSideCollapse(WrappedComponent) {
  class WithSideCollapse extends Component {
    constructor(props) {
      super(props);

      this.handleOnCollapseToggle = this.handleOnCollapseToggle.bind(this);
      this.state = { collapsed: false };
    }

    handleOnCollapseToggle() {
      this.setState((prevState) => ({ collapsed: !prevState.collapsed }));
    }

    render() {
      const { classes, collapseToRight, tooltipExpand, tooltipCollapse, intl } =
        this.props;
      const { collapsed } = this.state;

      return (
        <div className={classes.collapseWrapper}>
          {collapseToRight ? null : (
            <WrappedComponent {...this.props} collapsed={collapsed} />
          )}
          {collapsed ? (
            <Layout
              className={classes.showComponent}
              onClick={this.handleOnCollapseToggle}
            >
              <Icon
                color="status.info"
                icon="chevron-right"
                tooltip={
                  tooltipExpand ??
                  intl.formatMessage({
                    id: 'WithSideCollapse.showSidebar',
                    defaultMessage: 'Show Sidebar',
                    description: 'Tooltip for expanding the sidebar',
                  })
                }
              />
            </Layout>
          ) : (
            <Layout
              className={classes.hideComponent}
              onClick={this.handleOnCollapseToggle}
            >
              <Icon
                color="status.info"
                icon="chevron-left"
                tooltip={
                  tooltipCollapse ??
                  intl.formatMessage({
                    id: 'WithSideCollapse.hideSidebar',
                    defaultMessage: 'Hide Sidebar',
                    description: 'Tooltip for collapsing the sidebar',
                  })
                }
              />
            </Layout>
          )}
          {collapseToRight ? (
            <WrappedComponent {...this.props} collapsed={collapsed} />
          ) : null}
        </div>
      );
    }
  }

  WithSideCollapse.defaultProps = {
    collapseToRight: false,
  };

  WithSideCollapse.propTypes = {
    collapseToRight: PropTypes.bool,
    tooltipExpand: PropTypes.string,
    tooltipCollapse: PropTypes.string,
    intl: PropTypes.object.isRequired,
  };

  return injectSheet(styles)(injectIntl(WithSideCollapse));
}

export default withSideCollapse;
